var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-project-hero-block" }, [
    _c("div", { staticClass: "c-project-hero-block__background" }, [
      _c("img", {
        staticClass: "c-project-hero-block__background-img",
        attrs: { src: _vm.backgroundImage.src, alt: _vm.backgroundImage.alt },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-project-hero-block__buttons" }, [
      _c(
        "a",
        {
          staticClass:
            "c-project-hero-block__button c-project-hero-block__button--floorplan",
          attrs: {
            href: _vm.floorplanPdfUrl || "#",
            target: _vm.floorplanPdfUrl ? "_blank" : "_self",
            rel: _vm.floorplanPdfUrl ? "noopener noreferrer" : "",
            "aria-label": _vm.floorplanButtonText,
          },
        },
        [
          _c("i", {
            staticClass: "fa-regular fa-table-layout",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.floorplanButtonText))]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "c-project-hero-block__button c-project-hero-block__button--gallery",
          attrs: { "aria-label": _vm.galleryButtonText },
          on: { click: _vm.openGalleryModal },
        },
        [
          _c("i", {
            staticClass: "fa-regular fa-images",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.galleryButtonText))]),
          _vm._v(" "),
          _vm.galleryImages.length
            ? _c(
                "span",
                { staticClass: "c-project-hero-block__button-badge" },
                [
                  _vm._v(
                    "\n        (" +
                      _vm._s(_vm.galleryImages.length) +
                      ")\n      "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.view360Url
        ? _c(
            "button",
            {
              staticClass:
                "c-project-hero-block__button c-project-hero-block__button--360",
              attrs: { "aria-label": _vm.view360ButtonText, type: "button" },
              on: { click: _vm.open360Modal },
            },
            [
              _c("i", {
                staticClass: "fa-regular fa-street-view",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.view360ButtonText))]),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showGalleryModal
      ? _c(
          "div",
          {
            staticClass: "c-project-hero-block__modal",
            attrs: {
              role: "dialog",
              "aria-modal": "true",
              "aria-label": `${_vm.galleryButtonText} modal`,
            },
            on: { click: _vm.closeGalleryModal },
          },
          [
            _c(
              "div",
              {
                staticClass: "c-project-hero-block__modal-content",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "c-project-hero-block__modal-close",
                    attrs: {
                      "aria-label": "Close gallery modal",
                      type: "button",
                    },
                    on: { click: _vm.closeGalleryModal },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-regular fa-xmark",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-project-hero-block__gallery-wrapper" },
                  [
                    _vm.hasMultipleImages
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "c-project-hero-block__gallery-button c-project-hero-block__gallery-button--prev",
                            attrs: {
                              "aria-label": "Previous image",
                              type: "button",
                            },
                            on: { click: _vm.previousImage },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-regular fa-arrow-left",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "slide-show",
                      {
                        staticClass: "c-project-hero-block__gallery",
                        attrs: {
                          id: `project-gallery-${_vm.modalId}`,
                          "data-active-index": _vm.activeImageIndex,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "slider" },
                          _vm._l(_vm.galleryImages, function (image, index) {
                            return _c(
                              "div",
                              {
                                key: `slide-${index}`,
                                staticClass: "slider__item",
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: image.src,
                                    alt: image.alt,
                                    loading: index === 0 ? "eager" : "lazy",
                                  },
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.hasMultipleImages
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "c-project-hero-block__gallery-button c-project-hero-block__gallery-button--next",
                            attrs: {
                              "aria-label": "Next image",
                              type: "button",
                            },
                            on: { click: _vm.nextImage },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-regular fa-arrow-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.galleryImages.length > 1
                  ? _c(
                      "div",
                      { staticClass: "c-project-hero-block__thumbnails" },
                      _vm._l(_vm.galleryImages, function (image, index) {
                        return _c(
                          "button",
                          {
                            key: `thumb-${index}`,
                            staticClass: "c-project-hero-block__thumbnail",
                            class: {
                              "is-active": index === _vm.activeImageIndex,
                            },
                            attrs: {
                              "aria-label": `View image ${index + 1}`,
                              type: "button",
                            },
                            on: {
                              click: function ($event) {
                                _vm.activeImageIndex = index
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: image.thumbnail,
                                alt: `${image.alt} thumbnail`,
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.show360Modal
      ? _c(
          "div",
          {
            staticClass: "c-project-hero-block__modal",
            attrs: {
              role: "dialog",
              "aria-modal": "true",
              "aria-label": `${_vm.view360ButtonText} modal`,
            },
            on: { click: _vm.close360Modal },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "c-project-hero-block__modal-content c-project-hero-block__modal-content--360",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "c-project-hero-block__modal-close",
                    attrs: {
                      "aria-label": "Close 360 view modal",
                      type: "button",
                    },
                    on: { click: _vm.close360Modal },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-regular fa-xmark",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-project-hero-block__iframe-wrapper" },
                  [
                    _c("iframe", {
                      staticClass: "c-project-hero-block__iframe",
                      attrs: {
                        src: _vm.view360Url,
                        title: _vm.view360ButtonText,
                        allow:
                          "fullscreen; accelerometer; gyroscope; xr-spatial-tracking",
                        allowfullscreen: "",
                        loading: "lazy",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }